import React           from 'react';
import PropTypes       from '../PropTypes';
import ValueLabel      from '../ValueLabel';
import ComponentHelper from '../../helper/ComponentHelper';

class TableTextFormatter extends React.Component {
    render () {
        return (
            <ValueLabel
                value={this.props.value}
            />
        );
    }

    shouldComponentUpdate (nextProps, nextState) {
        return ComponentHelper.shouldComponentUpdate(
            this,
            Component,
            nextProps,
            nextState,
        );
    }
}

const Component = TableTextFormatter;

Component.propTypes = {
    value: PropTypes.any,
};

Component.defaultProps = {
    value: [],
};

Component.renderAffectingProps = Object.keys(Component.defaultProps);

Component.renderAffectingStates = [];

export default Component;